<template lang="pug">
.termo-compromisso-assinaturas
    .tc-header
    .divider
    .tc-content
        .tc-marca-dagua
            .declaracao(v-if='getMinutaInformacoes')
                MinutaTCATextoComponent(
                    v-if='processoLocal && !processoLocal.aderiuPra',
                    :informacoesMinuta='getMinutaInformacoes', :isRepresentanteLegal='processoLocal.isRepresentanteLegal'
                )
                MinutaTCPRATextComponent(
                    v-else,
                    :informacoesMinuta='getMinutaInformacoes', :isRepresentanteLegal='processoLocal.isRepresentanteLegal'
                )

            .assinaturas-obrigatorias(v-if='getAssinaturasInformacoes')
                AssinaturaBoxComponent(
                    v-for='(assinatura, i) in getAssinaturasInformacoes.assinaturas',
                    :key='i',
                    :assinatura='assinatura', :isRepresentanteLegal='processoLocal.isRepresentanteLegal'
                )
    .divider
    .tc-footer
        button-component(
            v-if='!isPerfilAssinou',
            v-tooltip='getButtonStyle.tooltip'
            :disabled='isPerfilAtualGO && !isGOUltimoAssinante'
            :label='getButtonStyle.label',
            :color='getButtonStyle.color',
            :background-color='getButtonStyle.backgroundColor'
            :icon='getButtonStyle.icon',
            @click.native='modalConfirmarAssinatura = true'
        )

    modal-component(
        v-if='getModalConfirmarAssinatura',
        title='Confirmar assinatura',
        @close='modalConfirmarAssinatura = false'
        width='35rem'
    )
        ModalConfirmacaoAssinatura(
            text='Para proteger sua segurança, é necessário confirmar sua identidade antes de prosseguir com a assinatura do termo de compromisso.',
            @confirmar:assinatura='validarDocumento($event)'
            @cancelar:assinatura='modalConfirmarAssinatura = false'
        )
</template>

<script>
import {
    getMinutaInformacoes,
    buscarPorId
} from '@/services/processo.service';
import {
    listarAssinaturas,
    assinarTermo,
    registrarAcessoTermo
} from '@/services/termoCompromisso.service';

import AssinaturaBoxComponent from '@/views/assinatura/components/AssinaturaBox.vue';
import MinutaTCATextoComponent from '@/views/assinatura/components/MinutaTCATextoComponent.vue';
import MinutaTCPRATextComponent from '@/views/assinatura/components/MinutaTCPRATextComponent.vue';
import ModalConfirmacaoAssinatura from '@/views/assinatura/components/ModalConfirmacaoAssinatura.vue';
import { Perfil } from '@/utils/constants.utils.js';
import {TipoAssinaturaEnum} from '@/enums/processo.enum.js';

export default {

    name: 'AssinaturaTermoCompromisso',

    props: {
        processo: {
            type: Object,
            required: false
        }
    },

    components: {
        AssinaturaBoxComponent,
        MinutaTCATextoComponent,
        MinutaTCPRATextComponent,
        ModalConfirmacaoAssinatura
    },

    data() {
        return {
            processoLocal: this.processo,
            informacoesMinuta: null,
            modalConfirmarAssinatura: false,
            listaAssinantes: null,
            assinaturasInformacoes: null,
            isAssinante: null,
            assinaturaAtual: null,
        };
    },

    computed: {
        isPerfilAssinou() {
            return this.verificaSePerfilAssinou();
        },

        getUsuario() {
            return this.$eu();
        },

        getButtonStyle() {
            return {
                tooltip: { label: this.isPerfilAtualGO ? 'Assinatura do(a) Gerente Operacional disponível apenas após todas as partes assinarem' : 'Assinar Termo', position: 'bottom'},
                label: 'Assinar',
                icon: 'mdi-check',
                backgroundColor: 'var(--primary-green)'
            };
        },

        isGOUltimoAssinante() {
            const naoAssinantes = this.assinaturasInformacoes?.assinaturas.filter(a => !Boolean(a.assinado));
            return (naoAssinantes && naoAssinantes.length === 1) && this.assinaturasInformacoes?.assinaturas.find(assinante => assinante.idTipoAssinaturaTermo === TipoAssinaturaEnum.GERENTE_OPERACIONAL.id);
        },

        isPerfilAtualGO() {
            return this.getUsuario.perfil === Perfil.GERENTE_OPERACIONAL;
        },

        isPerfilAtualUsuarioExterno() {
            return this.getUsuario.perfil === Perfil.USUARIO_EXTERNO;
        },

        getMinutaInformacoes() {
            return this.informacoesMinuta;
        },

        getModalConfirmarAssinatura() {
            return this.modalConfirmarAssinatura;
        },

        getAssinaturasInformacoes() {
            return this.assinaturasInformacoes;
        },

        isGOAssinou() {
            return (this.getUsuario.perfil === Perfil.GERENTE_OPERACIONAL) && this.verificaSePerfilAssinou();
        },

        isUsuarioPodeAssinar() {
            if (!this.getUsuario.dadosAssinanteExterno) {
                return this.assinaturasInformacoes?.assinaturas.some(a => a.idPessoaAssinante === this.getUsuario.id);
            }

            return true;
        },
    },

    async mounted() {
        try {
            if (!this.processoLocal) {
                let p = await buscarPorId(this.$dadosAssinanteExterno().idProcesso);
                this.atualizarProcesso(p);
            }

            this.informacoesMinuta = await getMinutaInformacoes(this.processoLocal.id);
            this.assinaturasInformacoes = await listarAssinaturas(this.informacoesMinuta.idTermo);
            this.assinaturaAtual = this.getAssinanteAtual();
            this.listaAssinantes = this.assinaturasInformacoes?.assinaturas.map(a => { return a.idPessoaAssinante });

            if (this.isPerfilAtualUsuarioExterno) {
                await registrarAcessoTermo(this.processoLocal.id);
            }

        } catch (error) {            
            this.$toast({
                showClose: true,
                message: 'Erro ao carregar informações da minuta!',
                type: 'error'
            });
        }
    },

    methods: {
        getAssinanteAtual() {
            if (this.isPerfilAtualUsuarioExterno) {
                return this.assinaturasInformacoes?.assinaturas.find(assinante => ((assinante.cpfCpnj === this.getUsuario.login) &&
                    (assinante.idTipoAssinaturaTermo === this.getUsuario.dadosAssinanteExterno.idTipoAssinatura)));
            } else {
                return this.assinaturasInformacoes?.assinaturas.find(assinante => assinante.idPessoaAssinante === this.getUsuario.id);
            }
        },

        atualizarProcesso(novoProcesso) {
            this.processoLocal = novoProcesso;
        },

        verificaSePerfilAssinou() {
            const assinante = this.getAssinanteAtual();
            return assinante?.assinado && assinante?.dataAssinatura;
        },

        abrirModalConfirmarAssinaturaMinuta() {
            this.modalConfirmarAssinatura = true;
        },

        getCookiePorNome(nome) {
            let cookies = document.cookie.split(';');

            for (let i = 0; i < cookies.length; i++) {
                let cookiePair = cookies[i].split('=');

                if (nome === cookiePair[0].trim()) {
                    return decodeURIComponent(cookiePair[1]);
                }
            }
            return null;
        },

        atualizaCookieAssinatura(codImovel) {
            let nomeCookie =  'isAssinado-' + codImovel;
            let cookie = this.getCookiePorNome(nomeCookie);
            if (cookie)
                this.setCookie(nomeCookie, true);
        },

        setCookie(nome, valor) {
            document.cookie = nome + '=' + encodeURIComponent(valor);
        },

        validarDocumento(documentoInformado) {
            const documento = this.getUsuario.login.replace(/\D/g, '');
            if (documento === documentoInformado) {
                this.modalConfirmarAssinatura = false;
                this.assinarTermo();
            } else {
                this.$toast({
                    showClose: true,
                    message: this.getUsuario.perfil === Perfil.GERENTE_OPERACIONAL ? 'O documento informado não corresponde ao documento do Gerente Operacional responsável pelo processo!': "O documento informado não corresponde ao documento do assinante logado!",
                    type: 'error'
                });
            }
        },

        async assinarTermo() {
            try {
                if (!this.isUsuarioPodeAssinar)
                    throw new Error('Este usuario não é um assinante autorizado!');

                this.assinaturaAtual.assinado = true;
                const date = new Date();
                this.assinaturaAtual.dataAssinatura = date.toISOString();

                let termo = {
                    idTermo: this.assinaturasInformacoes.idTermo,
                    assinaturas: this.assinaturasInformacoes.assinaturas
                };

                let result = await assinarTermo(termo, this.processoLocal.id);
                if (result !== null) {
                    if (this.isPerfilAtualUsuarioExterno)
                        this.atualizaCookieAssinatura(this.processoLocal.codImovel);
                    else {
                        const processo = buscarPorId(this.processoLocal.id);
                        this.atualizarProcesso(processo);
                    }

                    let msgSucessoCompromissaorio = '';

                    if (this.assinaturaAtual.idTipoAssinaturaTermo === TipoAssinaturaEnum.COMPROMISSARIO.id)
                        msgSucessoCompromissaorio = ' Após a assinatura de todas as partes,' +
                                    ' você receberá um e-mail com o Termo de Compromisso Oficial. ';

                    this.$toast({
                        showClose: true,
                        message: 'Termo de compromisso assinado com sucesso! ' + msgSucessoCompromissaorio,
                        type: 'success'
                    });
                }

            } catch (error) {
                this.$toast({
                    showClose: true,
                    message: 'Erro ao assinar termo de compromisso!',
                    type: 'error'
                });

                this.assinaturaAtual.assinado = false;
                this.assinaturaAtual.dataAssinatura = null;
            }
        },
    }
};
</script>

<style lang="scss">
.termo-compromisso-assinaturas {
    max-height: 75vh;
    overflow-y: auto;
    background-color: white;

    text-align: justify;

    .divider {
        width: 100%;
        border-bottom: 2px solid var(--primary-black);
        position: relative;
    }

    .tc-marca-dagua {
        // background: red;
        // opacity: 0.5;
    }

    .assinaturas-obrigatorias {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .tc-footer {
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}

.termo-compromisso-assinaturas::-webkit-scrollbar {
    width: 8px;
}

.termo-compromisso-assinaturas::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.termo-compromisso-assinaturas::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
